import Choices from "choices.js";

(() => {
    const queryParams = new URLSearchParams(window.location.search);
    let sourceIdentifier = '';
    if (queryParams.get('sourceIdentifier')) {
        sourceIdentifier = 'sourceIdentifier=' + queryParams.get('sourceIdentifier') + '&';
    }
    const listValue = document.getElementById('js-list') ? encodeURIComponent(document.getElementById('js-list').value) : '';
    const cityAutocompleteUrl = '/api/address/city?' + sourceIdentifier + 'postcode=X1X&list='+listValue;
    const postcodeAutocompleteUrl = '/api/address/postcode?' + sourceIdentifier + 'city=X2X&list='+listValue;
    const streetAutocompleteUrl = '/api/address/street?' + sourceIdentifier + 'postcode=X1X&city=X2X&list='+listValue;
    const numberAutocompleteUrl = '/api/address/number?' + sourceIdentifier + 'postcode=X1X&city=X2X&street=X3X&list='+listValue;
    const additionalAutocompleteUrl = '/api/address/additional?' + sourceIdentifier + 'postcode=X1X&city=X2X&street=X3X&number=X4X&list='+listValue;
    const validateParameter = '?' + sourceIdentifier + 'postcode=X1X&city=X2X&street=X3X&number=X4X&additional=X5X&list='+listValue;

    let choicesCity = null;
    let choicesPostcode = null;
    let choicesStreet = null;
    let choicesNumber = null;
    let choicesAdditional = null;
    let postcodeValue = '';
    let cityValue = '';
    let streetValue = '';
    let numberValue = '';
    let additionalValue = '';
    let postcodeValueLast = '';
    let cityValueLast = '';
    let streetValueLast = '';
    let numberValueLast = '';
    let additionalValueLast = '';

    let postcodeListener = true;
    let streetListener = true;
    let numberListener = true;
    let additionalListener = true;

    let choicesConfig = {
        duplicateItemsAllowed: false,
        searchResultLimit: 40,
        placeholder: true,
        placeholderValue: 'Bitte wählen',
        loadingText: 'Wird geladen ...',
        noResultsText: 'keine Ergebnisse gefunden',
        noChoicesText: 'Keine Auswahlmöglichkeiten',
        itemSelectText: '',
        removeItems: true
    };

    const cityAutocomplete = (addListener = true) => {
        const input = document.getElementById('js-city');
        if (!input) return;
        if (addListener) {
            choicesCity = new Choices(input, choicesConfig);
        }
        completeIt(cityAutocompleteUrl, input, choicesCity, addListener);
    };

    const postcodeAutocomplete = (addListener = true) => {
        const input = document.getElementById('js-postcode');
        if (!input) return;
        if (addListener) {
            choicesPostcode = new Choices(input, choicesConfig);
        }
        completeIt(postcodeAutocompleteUrl, input, choicesPostcode, addListener);
    };

    const streetAutocomplete = (addListener = true) => {
        const input = document.getElementById('js-street');
        if (!input) return;
        if (addListener) {
            choicesStreet = new Choices(input, choicesConfig);
        }
        completeIt(streetAutocompleteUrl, input, choicesStreet, addListener);
    };

    const numberAutocomplete = (addListener = true) => {
        const input = document.getElementById('js-number');
        const street = document.getElementById('js-street');
        if (!input) return;
        if (!street) return;
        if (addListener) {
            choicesNumber = new Choices(input, choicesConfig);
        }
        completeIt(numberAutocompleteUrl, input, choicesNumber, addListener);
    };


    const additionalAutocomplete = (addListener = true) => {
        const input = document.getElementById('js-additional');
        const number = document.getElementById('js-number');
        const street = document.getElementById('js-street');
        if (!input) return;
        if (!street) return;
        if (!number) return;
        if (addListener) {
            choicesAdditional = new Choices(input, choicesConfig);
        }
        completeIt(additionalAutocompleteUrl, input, choicesAdditional, addListener);
    };


    const validateOnSubmit = () => {
        const button = document.getElementById('js-availabilitycheck--button');
        const result = document.getElementById('js-check-result');
        if (!button) return;

        const submit = document.querySelector('.btn.btn-primary');
        if (submit) {
            submit.disabled = true;
            submit.classList.add('disabled');
        }

        button.addEventListener('click', (e) => {
            e.preventDefault();

            if (submit) {
                submit.disabled = true;
                submit.classList.add('disabled');
            }

            postcodeValue = document.getElementById('js-postcode').value;
            cityValue = document.getElementById('js-city').value;
            streetValue = document.getElementById('js-street').value;
            numberValue = document.getElementById('js-number').value;
            additionalValue = document.getElementById('js-additional').value;

            if (!postcodeValue || !cityValue || !streetValue || !numberValue) {
                result.innerHTML = '<span class="error">Bitte prüfen Sie Ihre Eingabe.</span>';
                return;
            }

            let ajaxUrl = validateParameter;
            ajaxUrl = ajaxUrl.replace(/X1X/, postcodeValue);
            ajaxUrl = ajaxUrl.replace(/X2X/, cityValue);
            ajaxUrl = ajaxUrl.replace(/X3X/, streetValue);
            ajaxUrl = ajaxUrl.replace(/X4X/, numberValue);
            ajaxUrl = ajaxUrl.replace(/X5X/, additionalValue);

            const xhr = new XMLHttpRequest();
            xhr.open('GET', '/api/address/query' + ajaxUrl);
            xhr.send(null);
            xhr.responseType = 'text';
            xhr.onreadystatechange = function () {
                const DONE = 4;
                const OK = 200;
                if (xhr.readyState === DONE) {
                    if (xhr.status === OK) {
                        const json_data = JSON.parse(xhr.responseText);
                        const data = Object.keys(json_data).map((key) => [key, json_data[key]]);
                        if (data.length < 1) {
                            result.innerHTML = 'Leider konnten wir diese Adresse in unseren Daten nicht finden.';
                        } else {
                            result.innerHTML = 'Produkt ist für diese Adresse verfügbar.';

                            const district = document.getElementById('js-district');
                            if (district) {
                                xhr.open('GET', '/api/address/district' + ajaxUrl);
                                xhr.send(null);
                                xhr.responseType = 'text';
                                xhr.onreadystatechange = function () {
                                    const DONE = 4;
                                    const OK = 200;
                                    if (xhr.readyState === DONE) {
                                        if (xhr.status === OK) {
                                            const districtData = JSON.parse(xhr.responseText);
                                            district.value = districtData.district;
                                            const formSubmit = document.querySelector(
                                                '.form-navigation button[type=submit]'
                                            );
                                            if (formSubmit) {
                                                if (typeof formSubmit.click == 'function') {
                                                    formSubmit.click();
                                                } else if (typeof ele.onclick == 'function') {
                                                    formSubmit.onclick();
                                                }
                                            }
                                        } else {
                                            console.log('Error: ' + xhr.status);
                                        }
                                    }
                                };
                            }

                            if (submit) {
                                submit.disabled = false;
                                submit.classList.remove('disabled');
                            } else {
                                e.target.classList.add('disabled');
                                e.target.closest('form').submit();
                            }
                        }
                    } else {
                        console.log('Error: ' + xhr.status);
                    }
                }
            };
        });
    };

    const completeIt = (autocompleteUrl, element, choices, addListener = true) => {
        const value = element.value;
        let ajaxUrl = autocompleteUrl;
        ajaxUrl = ajaxUrl.replace(/X1X/, postcodeValue);
        ajaxUrl = ajaxUrl.replace(/X2X/, cityValue);
        ajaxUrl = ajaxUrl.replace(/X3X/, streetValue);
        ajaxUrl = ajaxUrl.replace(/X4X/, numberValue);
        ajaxUrl = ajaxUrl.replace(/X5X/, additionalValue);

        choices.clearStore();
        choices.setChoices(async () => {
            try {
                const items = await fetch(ajaxUrl);
                if (value) {
                    setTimeout(function () {
                        choices.setChoiceByValue(value)
                    }, 200);
                }
                return items.json();
            } catch (err) {
                console.error(err);
            }
        });

        if (addListener) {
            element.addEventListener(
                'change',
                function (event) {
                    cityValue = document.getElementById('js-city').value;
                    postcodeValue = document.getElementById('js-postcode').value;
                    streetValue = document.getElementById('js-street').value;
                    numberValue = document.getElementById('js-number').value;
                    additionalValue = document.getElementById('js-additional').value;

                    if (cityValue && cityValue !== cityValueLast) {
                        postcodeAutocomplete(postcodeListener);
                        postcodeListener = false;
                    }
                    if (postcodeValue && cityValue &&
                        (
                            postcodeValue !== postcodeValueLast ||
                            cityValue !== cityValueLast
                        )
                    ) {
                        streetAutocomplete(streetListener);
                        streetListener = false;
                    }
                    if (postcodeValue && cityValue && streetValue &&
                        (
                            streetValue !== streetValueLast ||
                            postcodeValue !== postcodeValueLast ||
                            cityValue !== cityValueLast
                        )
                    ) {
                        numberAutocomplete(numberListener);
                        numberListener = false;
                    }
                    if (postcodeValue && cityValue && streetValue && numberValue &&
                        (
                            postcodeValue !== postcodeValueLast ||
                            cityValue !== cityValueLast ||
                            streetValue !== streetValueLast ||
                            numberValue !== numberValueLast
                        )
                    ) {
                        additionalAutocomplete(additionalListener);
                        additionalListener = false;
                    }

                    //save last state to check what was changed
                    cityValueLast = cityValue;
                    postcodeValueLast = postcodeValue;
                    streetValueLast = streetValue;
                    numberValueLast = numberValue;
                    additionalValueLast = additionalValue;

                },
                false,
            );
        }
    };

    document.addEventListener('readystatechange', () => {
        if (document.readyState !== 'complete') return;
        validateOnSubmit();
        cityAutocomplete();
    });
})();
